import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import { dateformation } from 'src/components/date-format-mdy';
import { formatCurrency } from '../../risk-register/feching';

// ----------------------------------------------------------------------

export default function UserTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  serialNumber,
}) {
  const {
    invoice_date,
    project,
    entry_type,
    description,
    account_chart,
    credit,
    debit,
    notes,
    status,
    vendor,
    customer,
  } = row;

  const confirm = useBoolean();
  const popover = usePopover();

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
        <TableCell>{serialNumber}</TableCell>
        <TableCell>{dateformation(invoice_date)}</TableCell>
        <TableCell>
          {entry_type === 'income'
            ? `${customer?.first_name} ${customer?.last_name}`
            : vendor?.name}
        </TableCell>
        <TableCell>{project?.name}</TableCell>
        {/*<TableCell>{account_type}</TableCell>*/}
        <TableCell>{description}</TableCell>
        <TableCell>{account_chart?.code}</TableCell>
        <TableCell>{formatCurrency(debit)}</TableCell>
        <TableCell>{formatCurrency(credit)}</TableCell>

        {/* <TableCell>{credit === 0 ? debit : credit}</TableCell> */}
        <TableCell>{notes}</TableCell>
        <TableCell>{entry_type || ''}</TableCell>
        <TableCell>{status === 1 ? 'Yes' : 'No'}</TableCell>
        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            onEditRow(row);
            console.log('>>>>>>>', row);
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure you want to delete?"
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              confirm.onFalse();
              onDeleteRow(row.id);
              console.log('>>>>>>>', row.id);
            }}
          >
            Delete
          </Button>
        }
      />
    </>
  );
}
UserTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
